const progressBar = require('nprogress');

$(() => {
    $('.js-share-button').on('click', function (e) {
        let url, data;
        if (typeof $(this).data('product') !== 'undefined') {
            url = '/productShareForm/' + $(this).data('product');
        } else {
            url = '/venueShareForm/' + $(this).data('venue');
        }

        e.preventDefault();
        $.ajax({
            method: 'post',
            url: url,
            data: data,
            complete: function() {
                $('.js-share-form').validate({
                    errorElement: 'div',
                    errorClass: 'label__error',
                    focusInvalid: true,

                    highlight: function(element, errorClass) {
                        const { form, id, name } = element;
                        const errorBlock = $(form).find(`div[for="${id ? id : name}"]`);

                        $(element).closest('.js-label').addClass('has-error');
                        $(element).closest('.js-field-dropdown__label')
                            .addClass('has-error');

                        $(errorBlock).addClass(errorClass);
                    },

                    unhighlight: function(element, errorClass) {
                        const { form, id, name } = element;
                        if (!id && !name) return;
                        const errorBlock = $(form).find(`div[for="${id ? id : name}"]`);

                        $(element).closest('.js-label')
                            .removeClass('has-error');

                        $(element).closest('.js-field-dropdown__label')
                            .removeClass('has-error');

                        $(errorBlock).removeClass(errorClass);
                    },

                    rules: {
                        email_to: {
                            required: true,
                            email: true
                        },
                        email_from: {
                            required: true
                        }
                    },

                    messages: {
                        email_to: {
                            required: 'This field is required.'
                        },
                        email_from: {
                            required: 'This field is required.'
                        }
                    }
                });
            }
        }).done(response => {
            $('.js-share-modal').fadeIn('easing', () => {
                $('.js-share-modal').addClass('is-open');
                $('.js-share-modal').removeAttr('style');
            });

            $('body').addClass('static');
            return $('.js-share-content').html(response.form);
        }).fail((e, rr, ors) => {
        });

    });

    $(document).on('click', '.js-close-window-modal',  (e) => {
        let target = e.target;
        if ($(e.target).hasClass('fa')) {
            target = $(e.target).parent();
        }

        if (!$(target).hasClass('js-close-window-modal')) return;

        $('body').removeClass('static');
        $('.js-share-modal').fadeOut('easing');
    });

    $(document).on('submit', '.js-share-form', function(e) {
        e.preventDefault();

        progressBar.configure({ parent: '.modal-window__btn' });
        progressBar.start();
        let form = $(this);
        $.ajax({
            method: 'post',
            url: form.attr('action'),
            data: form.serialize()
        }).done(response => {
            $('body').removeClass('static');
            $('.js-share-modal').fadeOut('easing');
            progressBar.done();
        }).fail((e,rr,ors) => {
            progressBar.done();
        });
    });
});



// WEBPACK FOOTER //
// ./resources/assets/js/components/product/share.js